var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "modal-close-btn-point" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-btn-container",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("SVGModalClose")],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-title-big" }, [
        _vm._v("\n            Выберете категорию\n        ")
      ]),
      _vm._v(" "),
      _c(
        "vue-custom-scrollbar",
        { staticClass: "category-list" },
        [
          _c(
            "div",
            {
              staticClass:
                "custom-categories-table-row custom-head-row modal-categories"
            },
            [
              _c("div", { staticClass: "custom-categories-table-label" }, [
                _vm._v("Название")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "custom-categories-table-label" }, [
                _vm._v("Выбрать")
              ])
            ]
          ),
          _vm._v(" "),
          _c("ProductCategoriesRecursive", {
            attrs: {
              canChooseAny: _vm.canChooseAny,
              categories: _vm.categories
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }